import script from "./alert-message.vue?vue&type=script&lang=jsx"
export * from "./alert-message.vue?vue&type=script&lang=jsx"

import "./alert-message.vue?vue&type=style&index=0&id=54225dd0&lang=scss"

const __exports__ = script;

export default __exports__